export default __webpack_public_path__ + "static/media/logistics-management.275140fc.svg";